import type { DonutViewDataItem } from './types'

import React from 'react'
import { isNil } from 'lodash/fp'

import { formatNumber, NumberFormats } from '@/shared/tools/locale'

type DonutLegendProps = {
	data: DonutViewDataItem[]
	formatValue?(value: number): string
	formatSubValue?(value: number): string
}
export default function DonutLegend({
	data,
	formatValue,
	formatSubValue = (v) => formatNumber(v, NumberFormats.Percent),
}: DonutLegendProps) {
	const renderSubvalue = (value: number) => formatSubValue?.(value) || value
	const renderValue = (value: number) => formatValue?.(value) || value

	return (
		<>
			{data.map(({ name, color, value, subvalue }) => {
				const subvalueItem = !isNil(subvalue) ? renderSubvalue(subvalue) : null
				const valueItem = renderValue(value)

				return (
					<div className='flex items-center justify-between text-xs' key={name}>
						<div className='flex items-center space-x-2'>
							<span
								className='size-2.5 shrink-0 rounded-xs'
								style={{ backgroundColor: color }}
							/>
							<p>{name}</p>
						</div>
						<span className='text-right font-semibold tabular-nums'>
							{!isNil(subvalue) ? `${subvalueItem} (${valueItem})` : valueItem}
						</span>
					</div>
				)
			})}
		</>
	)
}
